import api from './api';

export interface AttendeeTagResponse {
  predefinedTags: Array<{ label: string; description?: string }>;
  customTags: Array<{ id: string; name: string }>;
  allTags: string[];
}

export interface CreatedAttendeeTag {
  id: string;
  name: string;
}

const getAttendeeTags = async (agencySlug: string): Promise<AttendeeTagResponse> => {
  const res = await api.get<{ success: boolean; data: AttendeeTagResponse }>(
    `/agencies/${agencySlug}/attendees/tags`
  );
  return res.data.data;
};

const createAttendeeTag = async (agencySlug: string, name: string): Promise<CreatedAttendeeTag> => {
  const res = await api.post<{ success: boolean; data: CreatedAttendeeTag }>(
    `/agencies/${agencySlug}/attendees/tags`,
    { name }
  );
  return res.data.data;
};

const deleteAttendeeTag = async (agencySlug: string, tagId: string): Promise<void> => {
  await api.delete(`/agencies/${agencySlug}/attendees/tags/${tagId}`);
};

export default {
  getAttendeeTags,
  createAttendeeTag,
  deleteAttendeeTag,
};


